export const DEFAULT_ASSET_LOCATION = {
  latitude: 39.5,
  longitude: -98.35,
};

export const EXIT_VIEW_ZOOM_LEVEL = 17;



// WEBPACK FOOTER //
// ./src/compositions/DealerLocator/SearchResultsMap/constants.js